export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    height="20"
    width="20"
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    >
      <path
        d="M1 5h30v22H1zM1 11h30M7 17h11M7 21h7"
        strokeWidth="1.9999949999999997"
      />
    </g>
  </svg>
);
